import apiClient from "@/utils/httpClient";
import { getConfig } from "../../config.js";
import { v4 as uuidv4 } from "uuid";

export interface IntegrationStatus {
  id: string;
  provider: string;
  status: "connected" | "disconnected" | "expired" | "error";
  lastSyncAt?: string;
  externalAccountId?: string;
  externalCompanyName?: string | null;
  refreshTokenExpiresAt?: string | null;
}

export const getIntegrations = async (): Promise<IntegrationStatus[]> => {
  return apiClient.get<IntegrationStatus[]>("/integrations");
};

export const initiateQuickBooksConnect = async (): Promise<string> => {
  const config = getConfig();
  const state = uuidv4();
  sessionStorage.setItem('qb_oauth_state', state);

  const response = await apiClient.get<{ authUrl: string }>(
    "/integrations/quickbooks/connect",
    {
      state,
      redirectUri: `${config.get("app.baseUrl")}/integrations/quickbooks/callback`,
    }
  );

  if (!response?.authUrl) {
    throw new Error("Failed to get QuickBooks connection URL");
  }

  return response.authUrl;
};

export const quickBooksIntegrationCallback = async (): Promise<void> => {
  const response = await apiClient.postRaw<{ success: boolean }>(
    "/integrations/quickbooks/callback",
    { url: window.location.href }
  );

  if (!response?.success) {
    throw new Error("Failed to connect QuickBooks");
  }
};
